import React from 'react';
import ReactDOM from 'react-dom/client';
import { Spin } from 'antd';

import './index.scss';
import '@assets/styles/dark-theme.scss';
import { isDev } from '@config';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Mixpanel from '@analytics/mixpanel';
import GA from '@analytics/ga';
import { BrowserRouter as Router } from 'react-router-dom';
import 'antd/dist/reset.css';
import './i18n';
import { loadTheme } from '@utils/loadTheme';
import { applyBrandFromConfig } from '@utils/updateBrandAssets';
import GlobalErrorBoundary from '@Components/GlobalErrorBoundary/GlobalErrorBoundary';
import { captureUtmSource } from '@AuthCommon/utils';

captureUtmSource(window.location.search);

if (!isDev) {
  await loadTheme();
}
applyBrandFromConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GlobalErrorBoundary>
    <Router>
      <React.Suspense fallback={<div className='center'><Spin /></div>}>
        <App />
      </React.Suspense>
    </Router>
  </GlobalErrorBoundary>
);

serviceWorker.unregister();
Mixpanel.init();
GA.init();
